import axios from 'axios';
import Cookies from 'js-cookie';

// Instance cho Lumen API
export const lumenApi = axios.create({
  baseURL: process.env.VUE_APP_LUMEN_API_URL, // URL lấy từ .env
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Đảm bảo gửi cookie trong request
});

// Instance cho Node.js API
export const nodeApi = axios.create({
  baseURL: process.env.VUE_APP_NODE_API_URL, // URL lấy từ .env
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Đảm bảo gửi cookie trong request
});

// Hàm lấy token từ cookie thay vì sessionStorage
export function getToken() {
  return Cookies.get('accessToken');
}

// Hàm set token vào cookie thay vì sessionStorage
export function setToken(value) {
  //safari test chuyển secure: false vì không chấp nhận http
  Cookies.set('accessToken', value, { expires: 7, secure: true , sameSite: 'Lax'}); // Token hết hạn sau 7 ngày và chỉ gửi qua HTTPS
}

export function removeToken() {
  Cookies.remove('accessToken');
}

// Interceptor cho request để thêm token vào header nếu cần
lumenApi.interceptors.request.use(
  (config) => {
    const token = getToken(); // Lấy token từ cookie
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
